import { render } from "./CalendarButton.vue?vue&type=template&id=22c19a48&ts=true"
import script from "./CalendarButton.vue?vue&type=script&lang=ts"
export * from "./CalendarButton.vue?vue&type=script&lang=ts"

import "./CalendarButton.vue?vue&type=style&index=0&id=22c19a48&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__